import { mutate } from 'swr';
import useSWRMutationBase from 'swr/mutation';

import { FetcherParams, fetcher } from '@/data/fetcher';
import { useStoredOrganizationId } from '@/hooks/useStoredOrganizationId';
import { matchKeyPartial, useOrganizationId } from '@/hooks/useSwr';
import { HostRevisionSchema } from '@/types/schema';
import { hostApiProjectsPath } from '@/utils/constants';

export const useHostCreateRevisionRollbackMutation = (
  hostProjectId: string,
  revisionId: string
) => {
  const organizationId = useOrganizationId();
  const { orgId } = useStoredOrganizationId();
  return useSWRMutationBase<
    HostRevisionSchema,
    Error,
    FetcherParams<never, never>,
    null
  >(
    {
      method: 'POST',
      url: `${hostApiProjectsPath}/${hostProjectId}/revisions/${revisionId}/redeploy`,
      headers: { 'X-Tenant-Id': organizationId, 'X-Organization-Id': orgId },
    },
    (key, { arg }) => fetcher({ ...key, json: arg }),
    {
      onSuccess: () =>
        Promise.all([
          mutate(matchKeyPartial({ url: `${hostApiProjectsPath}` })),
          mutate(
            matchKeyPartial({ url: `${hostApiProjectsPath}/${hostProjectId}` })
          ),
          mutate(
            matchKeyPartial({
              url: `${hostApiProjectsPath}/${hostProjectId}/revisions`,
            })
          ),
        ]),
    }
  );
};
